import Localization from '~/client/src/shared/localization/LocalizationManager'

// localization: translated

/**
 * The app-wide way to keep a deleted entity readable — "[DELETED] Crane 1".
 * The marker is uppercased, matching the workflow-type lists. Falls back to the
 * generic unknown-object string when the last known name is gone too, so a raw
 * id is never shown to a user.
 */
export function getDeletedObjectLabel(name?: string): string {
  return name
    ? `[${Localization.translator.deleted.toUpperCase()}] ${name}`
    : Localization.translator.unknownDeletedObject
}
